import { render, staticRenderFns } from "./WiaaCertificationDetails.vue?vue&type=template&id=2e3274e7&scoped=true&"
import script from "./WiaaCertificationDetails.vue?vue&type=script&lang=js&"
export * from "./WiaaCertificationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3274e7",
  null
  
)

export default component.exports